import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { favoriteTabPath } from '../auth/postAuthRedirect';

// ============================================================================
// FavoriteTabRedirect (W1-C, E13) — die Startroute '/' fuehrt in den
// Lieblings-Tab statt hart auf /dashboard.
//
// Wahrheit ist der Server (`favorite_tab` aus /api/auth/me). Solange die
// Antwort fehlt oder das Feld noch nicht ausgeliefert wird (Paket W1-A),
// entscheidet der clientPrefs-Spiegel — deshalb zeigt der Kaltstart NICHT erst
// /dashboard und springt danach um (Karte C Risiko 5, „Doppel-Redirect").
//
// Eigene Datei statt Inline in routes.tsx, damit der Kaltstart-Fall ohne den
// kompletten Routenbaum testbar bleibt. Die Komponente wird ausschliesslich
// INNERHALB von RequireAuth gerendert — `useAuth()` ist hier also immer da.
// ============================================================================

export function FavoriteTabRedirect() {
  const { user } = useAuth();
  return <Navigate to={favoriteTabPath(user)} replace />;
}
